export type CancellationReason = {
  id: number;
  name: string;
};

// Reasons that cannot be charged to the hotel:
// 11 = "10% off - Friends & Family",
// 10 = "20 % off - Staycation Team" (Staycation internal).
// 9 = "10% off - Hotels"
export const HOTEL_INCOMPATIBLE_REASON_IDS = [10, 11, 9];
